import {
  editorDataFunction,
  componentInstanceData,
} from '@wix/editor-component-data-resolver';
import * as util from '#packages/util';

const { STRETCH, LEGACY_FULL } = util.imageTransform.fittingTypes;

export default {
  allowConnectToDB: true,
  allowedMobileOnly: true,
  overrideProportionalResize: editorDataFunction(
    componentInstanceData('componentProperties'),
    (compProps) =>
      compProps.displayMode !== STRETCH &&
      compProps.displayMode !== LEGACY_FULL,
  ),
};
